import React, { useState, useEffect, useRef } from "react";
import { getData, postData } from "../components/helpers/Data";
import { Spinner } from "../components/helpers/Spinner";
import MessageModal from "../components/helpers/Modal2";
import Modal5 from "../components/helpers/Modal5";
import { userSaveDetails } from "../components/helpers/UserSaveDetails";
import { Link } from "react-router-dom";
import Select2 from "react-select2-wrapper";
import "react-select2-wrapper/css/select2.css";
import $ from "jquery";
import { CurrencyCommaRemoval } from "../components/helpers/CurrencyCommaRemoval";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import { today3 } from "../components/helpers/today";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ReactDom from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Layout from "../components/layout/Layout_final";
import App from "../App";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const Sales = () => {
  //create array for logs when renewing corp
  const logData = userSaveDetails(2);

  $(function () {
    $("#drugs").select2();
  });

  //module variables
  const fullscreenRef = useRef(null);
  const [drugsData, setDrugsData] = useState({ all: [], filtered: [] });
  const [drugTypes, setDrugTypes] = useState([]);
  const [state, setState] = useState([]);
  const [units, setUnits] = useState([]);
  const [transactionType, setTransactionType] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [appendedDrug, setAppendedDrug] = useState([]);
  const [messageModal, setIsMessageModal] = useState(false);
  const [tableModal, setIsTableModal] = useState(false);
  const [responseModal, setResponseModal] = useState(false);
  const [response, setResponse] = useState(false);
  const [message, setMessage] = useState(false);
  const [selectedTransType, setSelectedTransType] = useState("0");
  const [totals, setTotals] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [balance, setBalance] = useState(0);
  const [hidden, setHidden] = useState(true);

  const home = () => {
    ReactDom.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>,
      document.getElementById("root")
    );
  };

  useEffect(() => {
    getData("fetch_state")
      .then((data) => {
        setState(data);
      })
      .catch((error) => {
        console.log(error);
      });
    getData("fetch_drug_types")
      .then((data) => {
        setDrugTypes(data);
      })
      .catch((error) => {
        console.log(error);
      });
    getData("fetch_drugs")
      .then((data) => {
        setDrugsData({ all: data, filtered: data });
      })
      .catch((error) => {
        console.log(error);
      });
    getData("fetch_units")
      .then((data) => {
        setUnits(data);
      })
      .catch((error) => {
        console.log(error);
      });
    getData("fetch_transaction_type")
      .then((data) => {
        setTransactionType(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    document.getElementById("start_point").focus();
    if (selectedTransType === "2") {
      setHidden(false);
    } else {
      setHidden(true);
    }
  }, [selectedTransType]);

  // useEffect(() => {
  //  const newRowId = new Date().getTime().toString();
  //  const row = {
  //    id: newRowId,
  //    new: (
  //      <>
  //        <td>
  //          <input
  //            id={newRowId + "input"}
  //            list="drug_search"
  //            className="form-control"
  //            style={{ width: "100%" }}
  //            onInput={handleSearch}
  //            onKeyDown={(e) =>
  //              e.key === "Enter"
  //                ? appendDrugRow(e)
  //                : e.key === "Delete"
  //                ? removeDrug(row.id)
  //                : null
  //            }
  //          />
  //          <datalist id="drug_search">
  //            {drugsData.all.map((dt) => {
  //              return (
  //                <option key={dt.code} value={dt.drugs}>
  //                  {dt.code}
  //                </option>
  //              );
  //            })}
  //          </datalist>
  //        </td>
  //        <td>
  //          <input
  //            name="code[]"
  //            className="form-control"
  //            style={{ width: "50px" }}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          {" "}
  //          <input
  //            name="drug[]"
  //            className="form-control"
  //            style={{ width: "300px" }}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          <input
  //            name="stock_id[]"
  //            className="form-control"
  //            style={{ width: "50px" }}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          <input
  //            name="expiry_date[]"
  //            className="form-control"
  //            style={{ width: "100px" }}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          <input
  //            type="number"
  //            name="quantity[]"
  //            className={"form-control"}
  //            defaultValue="1"
  //            min="1"
  //            onChange={calculateRowTotal}
  //          />
  //        </td>
  //        <td>
  //          <input
  //            type="text"
  //            name="price[]"
  //            className={"form-control"}
  //            defaultValue="0"
  //            readOnly
  //          />
  //        </td>

  //        <td>
  //          <input
  //            type="text"
  //            name="total[]"
  //            defaultValue="0"
  //            className={"form-control"}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          <button
  //            type="button"
  //            className="btn text-danger btn-sm"
  //            onClick={() => removeDrug(row.id)}
  //          >
  //            <i className="fas fa-trash fa-sm"></i>
  //          </button>
  //        </td>
  //      </>
  //    ),
  //  };

  //  setAppendedDrug((appendedDrug) => {
  //    return [...appendedDrug, row];
  //  });

  //  // Focus on the new row's input element
  //  setTimeout(() => {
  //    //   const newRowInput = document.querySelector(`#${row.id} input`);
  //    const newRowInput = document.getElementById(`${row.id}input`);
  //    console.log(row.id);
  //    if (newRowInput) {
  //      newRowInput.focus();
  //    }
  //  }, 100);
  // }, [])

  // append drug
  const appendDrugRow = (e) => {
    e.preventDefault();
    const newRowId = new Date().getTime().toString();
    const row = {
      id: newRowId,
      new: (
        <>
          <td>
            <input
              id={newRowId + "input"}
              list="drug_search"
              className="form-control"
              style={{ width: "100%" }}
              onInput={handleSearch}
              onKeyDown={(e) =>
                e.key === "Enter"
                  ? appendDrugRow(e)
                  : e.key === "Delete"
                  ? removeDrug(row.id)
                  : null
              }
            />
            <datalist id="drug_search">
              {drugsData.all.map((dt) => {
                return (
                  <option key={dt.code} value={dt.drugs}>
                    {dt.code}
                  </option>
                );
              })}
            </datalist>
          </td>
          <td>
            <input
              name="code[]"
              className="form-control"
              style={{ width: "50px" }}
              readOnly
            />
          </td>
          <td>
            {" "}
            <input
              name="drug[]"
              className="form-control"
              style={{ width: "300px" }}
              readOnly
            />
          </td>
          <td>
            <input
              name="stock_id[]"
              className="form-control"
              style={{ width: "50px" }}
              readOnly
            />
          </td>
          <td>
            <input
              name="expiry_date[]"
              className="form-control"
              style={{ width: "100px" }}
              readOnly
            />
          </td>
          <td>
            <input
              type="number"
              name="quantity[]"
              className={"form-control"}
              defaultValue="1"
              min="1"
              onChange={calculateRowTotal}
            />
          </td>
          <td>
            <input
              type="text"
              name="price[]"
              className={"form-control"}
              defaultValue="0"
              readOnly
            />
          </td>

          <td>
            <input
              type="text"
              name="total[]"
              defaultValue="0"
              className={"form-control"}
              readOnly
            />
          </td>
          <td>
            <button
              type="button"
              className="btn text-danger btn-sm"
              onClick={() => removeDrug(row.id)}
            >
              <i className="fas fa-trash fa-sm"></i>
            </button>
          </td>
        </>
      ),
    };

    setAppendedDrug((appendedDrug) => {
      return [...appendedDrug, row];
    });

    // Focus on the new row's input element
    setTimeout(() => {
      //   const newRowInput = document.querySelector(`#${row.id} input`);
      const newRowInput = document.getElementById(`${row.id}input`);
      console.log(row.id);
      if (newRowInput) {
        newRowInput.focus();
      }
    }, 100);
  };
  //remove bank row
  const removeDrug = async (id) => {
    // e.preventDefault();
    setAppendedDrug((appendedDrug) => {
      return appendedDrug.filter((row) => row.id !== id);
    });
  };

  useEffect(() => {
    calculateAllTotals();
  }, [appendedDrug]);

  //search drug
  const handleSearch = (e) => {
    e.target.closest("tr").children[1].children[0].value = "";
    e.target.closest("tr").children[2].children[0].value = "";
    e.target.closest("tr").children[6].children[0].value = "";
    const searchQuery = e.target.value;

    if (searchQuery === "") {
      e.target.closest("tr").children[1].children[0].value = "";
      e.target.closest("tr").children[2].children[0].value = "";
      e.target.closest("tr").children[6].children[0].value = "";
    }
    const filteredData = drugsData.all.filter(
      (item) =>
        (item.code !== null &&
          item.code.toString().toLowerCase() === searchQuery.toLowerCase()) ||
        (item.drugs !== null &&
          item.drugs
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase()))
    );

    e.target.closest("tr").children[1].children[0].value = filteredData[0].code;
    e.target.closest("tr").children[2].children[0].value =
      filteredData[0].drugs;
    e.target.closest("tr").children[3].children[0].value =
      filteredData[0].date_entered;
    e.target.closest("tr").children[4].children[0].value =
      filteredData[0].drug_user_update;
    e.target.closest("tr").children[6].children[0].value = parseFloat(
      filteredData[0].date_updated
    ).toLocaleString();

    //calculate totals
    let total =
      parseFloat(e.target.closest("tr").children[5].children[0].value) *
      parseFloat(
        CurrencyCommaRemoval(
          e.target.closest("tr").children[6].children[0].value
        )
      );
    e.target.closest("tr").children[7].children[0].value =
      total.toLocaleString();

    calculateAllTotals();
  };

  const calculateRowTotal = (e) => {
    const price = CurrencyCommaRemoval(
      e.target.closest("tr").children[6].children[0].value
    );
    let total = parseFloat(price) * parseFloat(e.target.value);
    e.target.closest("tr").children[7].children[0].value =
      total.toLocaleString();
    calculateAllTotals();
  };
  const calculateAllTotals = () => {
    let ttl = 0;
    document.querySelectorAll("#drug_tbl tbody tr").forEach((element) => {
      ttl += parseFloat(
        CurrencyCommaRemoval(element.children[7].children[0].value)
      );
    });
    document.getElementById("totals").innerHTML = ttl.toLocaleString();
  };

  const checkout = () => {
    let ttl = document.getElementById("totals").innerHTML;
    setTotals(ttl);
    setIsTableModal(true);
  };

  //checkout summary
  const calcBalance = (e) => {
    let blc = parseFloat(e.target.value) - parseFloat(totals.replace(/,/g, ""));
    setBalance(blc);
    setAmountPaid(e.target.value);
  };

  //save drug
  const saveSale = () => {
    closeTableModal();
    const frmData = new FormData(document.getElementById("sale_form"));
    frmData.append("user", localStorage.getItem("mpharma_username"));
    frmData.append("customer_no", document.getElementById("customer_no").value);
    frmData.append("trans_type", document.getElementById("trans_type").value);
    frmData.append("mpesa_code", document.getElementById("mpesa_code").value);

    //append access log details
    frmData.append("user_id", logData[0]);
    frmData.append("accessed_item", logData[1]);
    frmData.append("browser_type", logData[2]);
    frmData.append("os_type", logData[3]);

    postData(frmData, "save_sale")
      .then((data) => {
        setResponse(data.message);
        setResponseModal(true);
        document.getElementById("spinner").display = "none";
        printPdf(data.sale_code);
      })
      .catch((error) => {
        console.log(error);
        document.getElementById("spinner").display = "none";
      });
  };

  //print
  const printPdf = (code) => {
    let totals = document.getElementById("totals").innerHTML;
    let customer_no = document.getElementById("customer_no").value;
    let trans_type = document.getElementById("trans_type");
    let opts = trans_type.options[trans_type.selectedIndex].text;

    let header = `<thead><tr style="border-top:none;border-right:none;border-left:none;"><th>Item</th><th>Quantity</th><th>Price</th><th>Total</th></tr></thead>`;

    let rows = "";

    document.querySelectorAll("#drug_tbl tbody tr").forEach((element) => {
      rows += `
        <tr style="border:none;">
          <td>${element.children[2].children[0].value}</td>
          <td>${element.children[5].children[0].value}</td>
          <td>${element.children[6].children[0].value}</td>
          <td>${element.children[7].children[0].value}</td>
        </tr>
        `;
    });

    let body = `<tbody">${rows}</tbody>`;

    let footer = `<tfoot>
    <tr style="border-bottom:none;border-right:none;border-left:none;text-align:right;"><th colspan="2">Total</th><th colspan="2">${totals}</th></tr>
    <tr style="border-bottom:none;border-right:none;border-left:none;text-align:right;"><th colspan="2">Amount Paid</th><th colspan="2">${parseFloat(
      amountPaid
    ).toLocaleString()}</th></tr>
    <tr style="border-bottom:none;border-right:none;border-left:none;text-align:right;"><th colspan="2">Balance</th><th colspan="2">${parseFloat(
      balance
    ).toLocaleString()}</th></tr>
    </tfoot>`;

    let doc = `
    <div style="font-size:10px;">
    <p style="text-align:center;font-size:20px">MPHARMA</p>
    <p style="bottom:0;display:flex;text-align:center;">Receipt no : ${code} <span style="font-size:15px;">|</span>  Date :  ${today3()}</p>
    <p style="bottom:0;display:flex;text-align:center;"> Phone : ${customer_no} <span style="font-size:15px;">|</span> Payment Mode : ${opts}</p>
    <br/><br/>
    <table style="width:100%;">${header}${body}${footer}</table>
    <p style="bottom:0;display:flex;text-align:center;">0742551965 <span style="font-size:15px;">|</span> mwerezi.co.ke  <span style="font-size:15px;">|</span> info@mwerezi.co.ke</p>
    </div>
    `;

    var val = htmlToPdfmake(doc);
    var dd = {
      pageOrientation: "potrait",
      pageMargins: [10, 2, 2, 2],
      content: val,
      pageSize: "A7",
    };
    pdfMake.createPdf(dd).download();
  };
  //close message modal
  const closeResponseModal = () => {
    console.log(response);
    // setResponseModal(false);
    if (response == "Sucessful") {
      window.location.reload();
      
    }
  };
  //table modal
  const closeTableModal = () => {
    setIsTableModal(false);
    setBalance(0);
    // window.location.reload();
  };
  return (
    <div>
      <div className="container">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link onClick={home}>Home</Link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Sales
              </li>
            </ol>
          </nav>
          <hr />
        </div>
        <div className="card p-1">
          <div className="row">
            <div className="col-md-5">
              <button
                className="btn btn-success btn-sm col-2 mr-1"
                onClick={appendDrugRow}
              >
                add
              </button>
              {/* <button
                type="button"
                className="btn btn-secondary btn-sm col-2 mr-1"
                onClick={printPdf}
              >
                print
              </button> */}
              <button
                type="button"
                className="btn btn-info btn-sm col-2 mb-1"
                onClick={checkout}
              >
                pay
              </button>
            </div>

            <input
              type="text"
              className="form-control col-md-12 mb-1"
              placeholder="Customer No"
              id="customer_no"
            />

            <select
              id="trans_type"
              className="form-control col-md-12"
              onChange={(e) => setSelectedTransType(e.target.value)}
            >
              {transactionType.map((dt) => {
                return <option value={dt.code}>{dt.type}</option>;
              })}
            </select>
            <input
              type="text"
              className="form-control col-sm-2 ml-1"
              placeholder="Mpesa code"
              id="mpesa_code"
              hidden={hidden}
            />
          </div>
          <form id="sale_form" onSubmit={saveSale}>
            <div className="col-md-12 justify-content-center">
              <table
                className="table table-bordered"
                style={{ maxHeight: "500px" }}
                id={"drug_tbl"}
              >
                <thead className="table-fixed-header">
                  <tr>
                    <th>search</th>
                    <th>Code</th>
                    <th>Drugs</th>
                    <th>Stock Id</th>
                    <th>Expiry Date</th>
                    <th>Quantity</th>
                    <th>Price per Item</th>
                    <th>Total</th>
                    <th>Remove</th>
                  </tr>
                </thead>
                <tbody>
                  <td>
                    <input
                      id="start_point"
                      className="form-control"
                      onKeyDown={(e) =>
                        e.key === "Enter" ? appendDrugRow(e) : null
                      }
                    />
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {appendedDrug.map((data) => {
                    return <tr key={data.id}>{data.new}</tr>;
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>
                      <span
                        style={{
                          fontSize: "30px",
                          color: "green",
                          fontWeight: "bold",
                        }}
                      >
                        Total :
                      </span>
                    </th>
                    <th>
                      <span
                        style={{
                          fontSize: "30px",
                          margin: "0px",
                          textAlign: "left",
                          color: "green",
                          fontWeight: "bolder",
                        }}
                        id="totals"
                      >
                        0
                      </span>
                    </th>
                    <th></th>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div className={"row justify-content-center"}>
              <Spinner />
            </div>
          </form>
        </div>
      </div>
      {/*Message modal*/}
      <Modal5
        modalIsOpen={tableModal}
        closeModal={closeTableModal}
        // background="#0047AB"
        body={
          <div>
            <p className="text text-success font-weight-bold">
              Payment Summary
            </p>
            <table className="table table-bordered table-hover table-lg">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>paid</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      onInput={calcBalance}
                      
                    />
                  </td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={totals}
                   
                    />
                  </td>
                </tr>
                <tr>
                  <td
                 
                  >
                    Balance
                  </td>
                  <td
                    style={{
                      height: "auto",
                      color: "green",
                      fontWeight: "bolder",
                      backgroundColor: "yellow",
                    }}
                  >
                    {balance.toLocaleString()}
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <button className="btn btn-success btn-sm col-5" onClick={saveSale}>
                Checkout
              </button>{" "}
              <button className="btn btn-danger btn-sm col-5" onClick={closeTableModal}>
                Close
              </button>
            </p>
          </div>
        }
      />
      {/*Response modal*/}
      <MessageModal
        modalIsOpen={responseModal}
        closeModal={closeResponseModal}
        background="white"
        body={
          response !== "Sucessful" ? (
            <p className="text text-danger">{response}</p>
          ) : (
            <div className="text text-success h1">
              <i class="fas fa-check"></i> {response}
            </div>
          )
        }
      />
    </div>
  );
};

export default Sales;
